"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Context_1 = require("./Context");

var styled_1 = require("../styled");

var utils_1 = require("./utils");

var PropProvider =
/** @class */
function (_super) {
  __extends(PropProvider, _super);

  function PropProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getChildren = function () {
      var children = _this.props.children;
      if (!children) return null;

      if (React.Children.count(children) > 1) {
        return React.createElement("div", {
          className: "c-PropProvider"
        }, children);
      }

      return React.Children.only(children);
    };

    _this.enhanceContextProps = function (contextProps) {
      return utils_1.setGlobalApp(contextProps, _this.props.app);
    };

    _this.getThemeProviderProps = function (contextProps) {
      var _a;

      return _a = {}, // @ts-ignore
      _a[utils_1.propProviderDataAttr] = _this.props.app, _a;
    };

    return _this;
  }

  PropProvider.prototype.render = function () {
    var _this = this;

    return React.createElement(Context_1.default.Consumer, null, function (contextProps) {
      return React.createElement(Context_1.default.Provider, {
        value: utils_1.shallowMergeProps(_this.enhanceContextProps(contextProps), _this.props.value)
      }, React.createElement(styled_1.ThemeProvider, {
        theme: _this.getThemeProviderProps(contextProps)
      }, _this.getChildren()));
    });
  };

  PropProvider.defaultProps = {
    app: 'blue',
    value: {}
  };
  return PropProvider;
}(React.PureComponent);

exports.default = PropProvider;